import { useEffect, useState } from "react";
import { toast } from "sonner";

const STATUS = { delivered: "bg-[#1E1E1E] text-[#F3F1EC]", needs_attention: "bg-[#B3261E] text-white", paid: "bg-[#DB9130] text-[#1E1E1E]", checkout_started: "bg-[#EDE8DC] text-[#6E6E6E]" };

export default function KitOrdersList({ api }) {
  const [orders, setOrders] = useState(null);
  const load = () => api.get("/admin/starter-kit/orders").then((r) => setOrders(r.data.orders));
  useEffect(() => { load(); }, []);
  const retry = async (id) => {
    try { const { data } = await api.post(`/admin/starter-kit/orders/${id}/retry`); toast[data.status === "delivered" ? "success" : "error"](data.status === "delivered" ? "Delivered" : data.error); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Retry failed"); }
  };
  if (!orders) return <p className="text-[#6E6E6E]">Loading…</p>;
  if (!orders.length) return <p className="text-[#6E6E6E]" data-testid="sk-orders-empty">No paid orders yet.</p>;
  return (
    <div className="border-2 border-[#D3CFC0] divide-y-2 divide-[#EDE8DC]" data-testid="sk-orders-list">
      {orders.map((o) => (
        <div key={o.id} className="px-3 py-2 flex flex-wrap gap-3 items-center text-sm" data-testid={`sk-order-row-${o.id}`}>
          <span className={`text-[10px] uppercase font-[IBM_Plex_Mono] px-2 py-0.5 ${STATUS[o.status] || ""}`}>{o.status.replace("_", " ")}</span>
          <span className="font-head uppercase">{o.combo.sport} {o.combo.age} · {o.combo.practice_length}m</span>
          <span className="text-xs text-[#6E6E6E] flex-1">{o.is_gift ? `GIFT ${o.email} → ${o.recipient_email}` : o.email} · {new Date(o.created_at).toLocaleString()} · ${(o.price_cents / 100).toFixed(2)}{o.email_status ? ` · email ${o.email_status}` : ""}</span>
          {o.error && <span className="text-xs text-[#B3261E] w-full">{o.error}</span>}
          {["needs_attention", "delivered"].includes(o.status) && (
            <button data-testid={`sk-order-retry-${o.id}`} onClick={() => retry(o.id)} className="text-xs underline">{o.status === "delivered" ? "Re-deliver" : "Retry"}</button>
          )}
        </div>
      ))}
    </div>
  );
}
